(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "ramda", "reselect", "./utils/types"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("ramda"), require("reselect"), require("./utils/types"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.ramda, global.reselect, global.types);
    global.selectorToolkit = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _ramda, _reselect, _types) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.createSelector = createSelector;
  Object.defineProperty(_exports, "composeSelectors", {
    enumerable: true,
    get: function () {
      return _reselect.createSelector;
    }
  });

  function createSelector(pathString) {
    if (!(0, _types.isString)(pathString)) {
      throw new TypeError(`createSelector() expects a string as its only argument, got ${String(pathString)} instead`);
    }

    if ((0, _ramda.isEmpty)(pathString)) {
      throw new TypeError('createSelector() received empty string as argument, supply a path string');
    }

    return state => (0, _ramda.path)(pathString.split('.'), state);
  }
});